import { View, Text } from 'react-native'
import React from 'react'
import LottieView from 'lottie-react-native'
import { ThemedText, ThemedView } from '@app/theme'
import { useAppSelector } from '@app/store/hooks'


const BankPennyDropModal = ({ lottie }: { lottie: any }) => {

    const userName = useAppSelector((state) => state.auth?.userDetails?.linkedBorrowerAccounts[0]?.accountHolderName)

    return (
        <ThemedView padding='lg' justifyContent='center' alignItems='center'>
            <LottieView source={lottie} autoPlay loop style={{ width: 99, height: 99 }} />
            <ThemedText variant='b2s' mt='lg' mb='2xl' color='text-primary'>Depositing ₹1</ThemedText>
            <ThemedView mb='lg' bg='bg-fill-warning' paddingHorizontal='lg' paddingVertical='sm' borderRadius='md'>
                <ThemedText textAlign='center' variant='b3r' color='text-primary'>To verify account, we will deposit ₹1 and match account holder name with name as per PAN <ThemedText variant='b3b' color='text-primary'>"{userName}"</ThemedText> </ThemedText>
            </ThemedView>
            <ThemedText mt='2xl' variant='b4r' color='text-secondary'>It may take up to 30 seconds...</ThemedText>
        </ThemedView>
    )
}

export default BankPennyDropModal